export default __webpack_public_path__ + "static/media/cooperation.e43b190f.png";